import MProgress from './MProgress.vue';

MProgress.install = (app) => {
  app.component('MProgress', MProgress);
};

export { MProgress };
